export default "__VITE_ASSET__Ddm5_Rmu__"